<template>
  <div>
    <alert v-for="a in alerts" :type="a.type" :key="a.id">
      <span v-html="a.message"></span>
    </alert>
  </div>  
</template>

<script>
import Alert from './Alert.vue'
export default {
  props: {
    alerts: Array,
  },
  components: {
    Alert,
  },
}
</script>